<script>
module.exports = {
  name: 'ErrorDialog',
  data() {
    return {
      general: 'There was an error processing your request. Please try again later.',
    };
  },
  computed: {
    show() {
      return !!this.$store.state.showErrorMsg;
    },
    msg() {
      return this.$store.state.errorMsg ? this.$store.state.errorMsg : this.general;
    },
  },
  methods: {
    hide() {
      this.$store.dispatch('hideErrorMsg');
    },
  },
};
</script>

<template>
  <dialog class="error-dialog" v-if="show">
    <div class="close-button" @click="hide" style="cursor: pointer">
      <img
        class="favorite-icon-svg"
        :src="'../media/components/account-2/red-close-icon.svg'"
        alt="Close"
      />
    </div>
    <div class="error-dialog-content">
      <div class="error-dialog-icon">!</div>
      <div class="error-dialog-text">{{ msg }}</div>
    </div>
  </dialog>
</template>
